
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"48","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#8B96B8","fill-rule":"evenodd","d":"M31 6a3 3 0 013 3v25a3 3 0 01-2.985 3l-.29 2.366A3 3 0 0127.746 42h-7.494a3 3 0 01-2.977-2.634L16.984 37l-.16-.004A3 3 0 0114 34V9a3 3 0 013-3h14zm-.992 31H17.992l.276 2.244A2 2 0 0020.253 41h7.494a2 2 0 001.985-1.756L30.008 37zM31 7H17a2 2 0 00-2 2v25a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2z"}})])
          )
        }
      }
    